<template>
  <div class="m-2">
    <b-row>
      <b-col cols="12">
        <div class="d-flex align-items-center justify-content-end">
          <div class="add-on-border-group search-dynamic-table">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend
                is-text
                class="add-on-border add-on-border"
              >
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input
                v-model="searchValue.query"
                @input="onSearch"
                class="d-inline-block mr-2 add-on-border-input"
                placeholder="Search..."
              />
            </b-input-group>
          </div>
          <b-button
            class="w-nowrap mr-2"
            variant="success"
            @click="openReportModal(searchValue.query)"
          >
            <span>Export .CSV</span>
          </b-button>
          <b-dropdown
            variant="link"
            no-caret
            toggle-class="p-0"
            right
            @hidden="onCloseDropdown"
          >
            <template #button-content>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="secondary"
                class="btn-icon"
              >
                <feather-icon icon="SettingsIcon" size="18" />
              </b-button>
            </template>

            <b-form-checkbox-group v-model="selectedColumn">
              <b-dropdown-form>
                <div class="d-flex flex-column">
                  <b-form-checkbox
                    v-for="column in displayedColumns"
                    :key="column.key"
                    :value="column.key"
                    class="custom-checkbox-square custom-control-success options-checkbox"
                    @change="onSelectCheckBox"
                  >
                    {{
                      $i18n.locale == "th" ? column.label_th : column.label_en
                    }}
                  </b-form-checkbox>
                </div>
              </b-dropdown-form>
            </b-form-checkbox-group>
          </b-dropdown>
        </div>
      </b-col>
    </b-row>
    <history-report-modal
      v-if="modalPopup.report"
      @onCloseModal="closeReportModal"
      :moduleTypeKey="defaultReportFilterType.module"
      :moduleKey="defaultReport.customer"
    />
  </div>
</template>

<script>
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";

import { watch, ref, getCurrentInstance, reactive } from "@vue/composition-api";

import useModal from "@/@core/components/base-modal/hooks/useModal";
import HistoryReportModal from "@/views/pages/report/history-report/HistoryReportModal.vue";
import {
  defaultReport,
  defaultReportFilterType,
  defaultReportCategory,
} from "@/configs/dynamic-config/dynamic-report";

// report fix by brand
import useExportCsv from "./useExportCsv";
import { reportCustom } from "@/constants/report/report-custom";

export default {
  directives: {
    Ripple,
  },
  components: {
    vSelect,
    HistoryReportModal,
  },
  props: {
    pagination: Object,
    onSelectEntities: Function,
    onSearch: Function,
    searchValue: Object,
    isCreate: Boolean,
    displayedColumns: Array,
    filterColumns: Array,
    onSelectFilter: Function,
  },

  setup(props) {
    const { openModal, closeModal } = useModal();
    const { exportCsv } = useExportCsv();
    const vm = getCurrentInstance().proxy;

    const selectedColumn = ref([]);
    let hasSelected = false;
    const modalPopup = reactive({
      report: false,
    });

    const initSelectedColumn = () => {
      const newSelectedColumn = [];

      props.displayedColumns.map((column) => {
        if (column.is_display) {
          newSelectedColumn.push(column.key);
        }
      });

      selectedColumn.value = newSelectedColumn;
    };

    const onCloseDropdown = () => {
      if (hasSelected) {
        vm.$emit("optionSelected", selectedColumn.value);
      }
      hasSelected = false;
    };

    const onSelectCheckBox = (updatedColumn) => {
      selectedColumn.value = updatedColumn;
      hasSelected = true;
    };

    const openReportModal = (searchValue) => {
      let isDynamicReport =
        reportCustom.used.indexOf(
          new URLSearchParams(window.location.search).get("brandRef")
        ) == -1
          ? true
          : false;
      if (isDynamicReport) {
        modalPopup.report = true;
        return openModal();
      }
      return exportCsv(searchValue);
    };

    const closeReportModal = (searchValue) => {
      modalPopup.report = false;
      closeModal();
    };

    watch(
      () => props.displayedColumns,
      (newVal, oldVal) => {
        initSelectedColumn();
      },
      { deep: true }
    );

    return {
      selectedColumn,
      hasSelected,
      modalPopup,
      defaultReport,
      defaultReportFilterType,
      defaultReportCategory,
      onCloseDropdown,
      onSelectCheckBox,
      openReportModal,
      closeReportModal,
    };
  },
};
</script>

<style></style>
